import React, { Component } from "react";

class Header extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <header>
                <span>CV Creation Application</span>
            </header>
        )
    }
}

export default Header;